export const VenueType = [
  { title: "Pub", value: "pub" },
  { title: "Bar", value: "bar" },
  { title: "Taproom", value: "taproom" },
  { title: "Bottle Shop", value: "bottle_shop" },
  { title: "Restaurant", value: "restaurant" },
  { title: "Distributor/Wholesaler", value: "distributor_wholesaler" },
  { title: "Importer/Exporter", value: "importer_exporter" },
  { title: "Online shop", value: "online_shop" },
  {
    title: "Entertainment venue (e.g. cinema, theatre, etc.)",
    value: "entertainment_venue",
  },
  { title: "Club (e.g. sports, social, etc.)", value: "club" },
  { title: "Office", value: "office" },
  { title: "Hotel", value: "hotel" },
  { title: "Supermarket", value: "supermarket" },
  { title: "Other", value: "other" },
];
